var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#EB9928"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1801 14.4095C31.1801 13.0795 32.2601 11.9995 33.5901 11.9995C34.9201 11.9995 36.0001 13.0795 36.0001 14.4095C36.0001 15.7395 34.9201 16.8195 33.5901 16.8195C32.2601 16.8195 31.1801 15.7395 31.1801 14.4095ZM27.33 24.7588L30.22 21.0298L30.18 21.0498C30.34 20.8298 30.37 20.5498 30.26 20.2998C30.151 20.0498 29.91 19.8798 29.651 19.8598C29.38 19.8298 29.111 19.9498 28.95 20.1698L26.531 23.2998L23.76 21.1198C23.59 20.9898 23.39 20.9388 23.19 20.9598C22.991 20.9898 22.811 21.0988 22.69 21.2588L19.731 25.1098L19.67 25.1998C19.5 25.5188 19.58 25.9288 19.88 26.1498C20.02 26.2398 20.17 26.2998 20.34 26.2998C20.571 26.3098 20.79 26.1888 20.93 25.9998L23.44 22.7688L26.29 24.9098L26.38 24.9688C26.7 25.1388 27.1 25.0598 27.33 24.7588ZM29.45 13.7798C29.41 14.0298 29.39 14.2798 29.39 14.5298C29.39 16.7798 31.21 18.5988 33.45 18.5988C33.7 18.5988 33.94 18.5698 34.19 18.5298V26.5988C34.19 29.9898 32.19 31.9998 28.79 31.9998H21.401C18 31.9998 16 29.9898 16 26.5988V19.1998C16 15.7998 18 13.7798 21.401 13.7798H29.45Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHGraph);
export default __webpack_public_path__ + "static/media/HGraph.e2bf2213.svg";
export { ForwardRef as ReactComponent };